module.exports = __webpack_public_path__ + "static/media/02.45567194.jpg";